import { render } from "./examinationDetails.vue?vue&type=template&id=1fc2fe14"
import script from "./examinationDetails.vue?vue&type=script&lang=js"
export * from "./examinationDetails.vue?vue&type=script&lang=js"

import "./examinationDetails.vue?vue&type=style&index=0&id=1fc2fe14&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__